import { render, staticRenderFns } from "./PropertyContacts.vue?vue&type=template&id=6e062457&"
import script from "./PropertyContacts.vue?vue&type=script&lang=js&"
export * from "./PropertyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports